import React from 'react';
import {
	Box,
	Typography,
	Grid,
	Card,
	CardContent,
} from '@mui/material';

interface AnalyticsTabProps {
	expenseId: string;
}

function AnalyticsTab({ expenseId }: AnalyticsTabProps) {
	// Placeholder for future expense analytics implementation
	return (
		<Box>
			<Typography variant="h6" gutterBottom>
				Expense Analytics
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
				View analytics and trends for this expense category
			</Typography>

			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Card>
						<CardContent>
							<Box
								sx={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									minHeight: 200,
									bgcolor: 'grey.50',
									borderRadius: 1,
								}}
							>
								<Box sx={{ textAlign: 'center' }}>
									<Typography variant="h6" color="text.secondary" gutterBottom>
										Analytics Coming Soon
									</Typography>
									<Typography variant="body2" color="text.secondary">
										Expense trends and insights will be available here
									</Typography>
									<Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
										Expense ID: {expenseId}
									</Typography>
								</Box>
							</Box>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Box>
	);
}

export default AnalyticsTab;
